<template>
  <div>
    <b-tabs v-model="activeTab" @input="onTabChange" vertical nav-wrapper-class="w-25">
      <b-tab title="Profil" active><TabIdentitasDiri :data="data" :activeTab="activeTab" @alertFromChild="triggerAlert($event)" /></b-tab>
      <b-tab title="Asuransi"><TabAsuransi :asuransi="asuransi" :data="data" :activeTab="activeTab" /></b-tab>
      <b-tab title="Riwayat Pendidikan"><TabPendidikanProfil :data="data" :activeTab="activeTab" /></b-tab>
      <b-tab title="Pengalaman Kerja"><TabKerjaProfil :data="data" :activeTab="activeTab" /></b-tab>
      <b-tab title="Dokumen/Lampiran"><TabLampiranProfil :data="data" :activeTab="activeTab" /></b-tab>
      <b-tab title="Keluarga"><TabKeluargaProfil :data="data" :activeTab="activeTab" /></b-tab>
    </b-tabs>
  </div>
</template>
<script>
import TabIdentitasDiri from "./identitasDiri/tabIdentitasDiri.vue";
import TabAsuransi from "./asuransi/tabAsuransiProfil.vue";
import TabPendidikanProfil from "./pendidikan/tabPendidikanProfil.vue";
import TabKerjaProfil from "./kerja/tabKerjaProfil.vue";
import TabLampiranProfil from "./lampiran/tabLampiranProfil.vue";
import TabKeluargaProfil from "./keluarga/tabKeluargaProfil.vue";
export default {
  props: ["data", "asuransi"],
  components: {
    TabIdentitasDiri,
    TabAsuransi,
    TabPendidikanProfil,
    TabKerjaProfil,
    TabLampiranProfil,
    TabKeluargaProfil,
  },
  data() {
    return {
      editAsuransi: false,
      activeTab: 0,
    };
  },
  methods: {
    onTabChange(newIndex) {
      const titles = ["Profil", "Absensi", "Pelanggaran", "Peringatan", "Penggajian"];
      console.log("Tab title:", titles[newIndex]);
    },
    triggerAlert(event) {
      let vm = this;
      // console.log("tab profil");
      vm.$emit("alertFromChild", event);
    },
  },
};
</script>

<style scoped>
.tab-content > .tab-pane {
  padding: 10px 15px;
  /* background-color: whitesmoke; */
  border-radius: 10px;
}
</style>
